import * as React from "react";

// MATERIAL UI COMPONENTS
import Avatar from "@mui/material/Avatar";
import Divider from "@mui/material/Divider";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import { LightDarkGreyBox } from "../../styled";
// ICONS
import Typography from "@mui/material/Typography";

export default function EntregaFacilCard(props) {
  const logo_url = "/images/ifood-easy-delivery.png";

  return (
    <LightDarkGreyBox sx={{ minHeight: 300 }}>
      <CardHeader
        avatar={
          <Avatar
            alt="entrega-facil-logo"
            src={logo_url}
            sx={{ width: 56, height: 56 }}
          />
        }
        title="Entrega Fácil"
        subheader="Ifood"
      />
      <CardContent sx={{ flex: "1 0 auto" }}>
        <Typography
          id="ifood-entrega-facil-status-info"
          variant="body2"
          align="center"
        >
          Tudo certo! Para usar o Entrega Fácil você só precisa cadastrar um
          restaurante Ifood na sua conta do Slapie, você poderá usar esse
          restaurante para pedir mototobys para todas as suas plataformas
          cadastradas.
        </Typography>
        <Divider variant="middle" sx={{ my: 2 }} />
        <Typography
          id="ifood-entrega-facil-how-to-info"
          variant="caption"
          align="center"
        >
          Basta clicar no Menu "Restaurantes" na barra de menus do Slapie.
        </Typography>
      </CardContent>
    </LightDarkGreyBox>
  );
}
